import { makeRequest, buildResponse, buildError } from 'helpers/requestHandler'

export default class Station {
	tocs = {
		AR: "Alliance Rail",
		NT: "Arriva Trains Northern",
		AW: "Arriva Trains Wales",
		CC: "c2c",
		CS: "Caledonian Sleeper",
		CH: "Chiltern Railway",
		XC: "CrossCountry",
		EM: "East Midlands Trains",
		ES: "Eurostar",
		FC: "First Capital Connect (defunct)",
		HT: "First Hull Trains",
		GX: "Gatwick Express",
		ZZ: "GB Railfreight",
		GN: "Govia Thameslink Railway (Great Northern)",
		TL: "Govia Thameslink Railway (Thameslink)",
		GC: "Grand Central",
		LN: "Great North Western Railway",
		GW: "Great Western Railway",
		LE: "Greater Anglia",
		HC: "Heathrow Connect",
		HX: "Heathrow Express",
		IL: "Island Lines",
		LS: "Locomotive Services",
		LM: "London Midland",
		LO: "London Overground",
		LT: "LUL District Line – Wimbledon",
		ME: "Merseyrail",
		LR: "Network Rail (On-Track Machines)",
		TW: "Nexus (Tyne & Wear Metro)",
		NY: "North Yorkshire Moors Railway",
		SR: "ScotRail",
		SW: "South Western Railway",
		SJ: "South Yorkshire Supertram",
		SE: "Southeastern",
		SN: "Southern",
		SP: "Swanage Railway",
		XR: "TfL Rail",
		TP: "TransPennine Express",
		VT: "Virgin Trains",
		GR: "Virgin Trains East Coast",
		WR: "West Coast Railway Co.",
	}

	list(key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/stations', 'POST', {
				'key' : key
			}).then((response) => {
				if(response.ok) {
					response.json().then((json) => resolve(buildResponse(true, json)))
				} else {
					switch (response.status){
						case 403:
							return buildError(response, reject, 'Not enough permissions to perform operation')
						case 206:
							return buildError(response, reject, 'No valid stations')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

	listValidTocs(key) {
		return new Promise((resolve, reject) => {
			makeRequest('/timetables/operators', 'POST',{
				'key': key
			}).then((response) => {
				if(response.ok){
					response.json().then((json) => resolve(buildResponse(true, json)))
				} else {
					switch (response.status){
						case 403:
							return buildError(response, reject, 'Invalid auth key')
						default:
							return buildError(response, reject, 'Unknown')
					}
				}
			})
		})
	}

}


// WEBPACK FOOTER //
// ./src/thunks/classes/Station.js